import BranchSalesPanel from './branchSalesPanel.container';

export default BranchSalesPanel;